import React from 'react';

import ReactSelect from 'components/shared/FormAdapters/FormBase/ReactSelect';
import useSimpleValueSelect from 'hooks/useSimpleValueSelect';

const defaultProps = {
  value: undefined,
  options: [],
  menuPlacement: 'bottom',
};

const SimpleValueAdapter = (props) => {
  const { value, onChange, options } = props;
  const [simpleValue, simpleOnChange] = useSimpleValueSelect({ value, onChange, options });

  return <ReactSelect {...props} onChange={simpleOnChange} value={simpleValue} />;
};

SimpleValueAdapter.defaultProps = defaultProps;

export default SimpleValueAdapter;
